/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateDayView = (styles) => {
  const {
    backgroundColor,
    secondaryBackgroundColor,
    titleFontColor,
    contentCardColor,
  } = styles

  const dayViewBackgroundImageSelector =
    '.content_wall_slide .slide_background_image_wrapper'
  const dayViewSlideContentsSelector = '.content_wall_slide .slide_contents'
  const contentHeaderSelector = '.content_wall_slide header.header'
  const contentHeaderContentSelector = '.content_wall_slide .header_content'
  const viewerContentHeaderContentSelector =
    '.presentation_viewer .content_wall_slide .header_content'
  const viewportSelector = '.content_wall_slide .viewport'
  const timelineRegionSelector = '.content_wall_slide .header .timeline_region'
  const timelineSelector = '.presentation_slide .timeline'
  const viewerMomentsRegionSelector =
    '.presentation_viewer .content_wall_slide .moments_region'
  const dayViewMomentColumnSelector =
    '.presentation_slide.content_wall_slide .moment + .moment .column'
  const dayViewPostsContainerSelector =
    '.presentation_slide.content_wall_slide .moment .posts_container'
  const dayViewEndofContentSelector =
    '.presentation_slide.content_wall_slide .end_of_content'
  const dayViewEndofContentPostsContainerSelector =
    '.presentation_slide.content_wall_slide .end_of_content .posts_container'
  const darkAttributeSelector = '[class*="--dark"]'

  // Selectors for setting colors
  const timelineBarSelector = '.presentation_slide.content_wall_slide .bar'
  const timelineUnitIsToday =
    '.presentation_slide.content_wall_slide .unit.is-today'
  const activeSelector = '.content_wall_slide .highlights .duration'
  const dayViewActiveDateSelector =
    '.content_wall_slide .unit.is-active .date_number'
  const dayViewActiveDayLetterSelector =
    '.content_wall_slide .unit.is-active .date_letter'
  const dayViewMonthSelector =
    '.content_wall_slide .timeline_layout .timeline_wrapper ' +
    '.timeline .viewport .timeline_container .month-labels .label'
  const dayViewDateSelector = '.content_wall_slide .date_number'
  const momentDateSelector = '.content_wall_slide .moment .header .date'
  const dayViewMomentTitleSelector =
    '.content_wall_slide .moment .header .title'
  const isTodayDate =
    '.presentation_slide.content_wall_slide .unit.is-today .date_number'
  const momentsRegionHeader =
    '.presentation_slide.content_wall_slide .moments_region_header'

  const fiftyPercentAlpha = '7C'
  const transparentBackgroundColor =
    secondaryBackgroundColor + fiftyPercentAlpha
  const transparentTitleFontColor = titleFontColor + fiftyPercentAlpha

  const selectors = [
    new Selector({
      selection: dayViewSlideContentsSelector,
      required: true,
    }),
    new Selector({
      selection: contentHeaderSelector,
      required: true,
    }),
    new Selector({
      selection: contentHeaderContentSelector,
      required: true,
    }),
    new Selector({
      selection: viewerContentHeaderContentSelector,
    }),
    new Selector({
      selection: viewportSelector,
      required: true,
    }),
    new Selector({
      selection: timelineRegionSelector,
      required: true,
    }),
    new Selector({
      selection: timelineSelector,
      required: true,
    }),
    new Selector({
      selection: dayViewMonthSelector,
      required: true,
    }),
    new Selector({
      selection: dayViewDateSelector,
      required: true,
    }),
    new Selector({
      selection: momentDateSelector,
      required: true,
    }),
    new Selector({
      selection: dayViewMomentTitleSelector,
      required: true,
    }),
    new Selector({
      selection: viewerMomentsRegionSelector,
    }),
    new Selector({
      selection: activeSelector,
    }),
    new Selector({
      selection: dayViewMomentColumnSelector,
    }),
    new Selector({
      selection: dayViewPostsContainerSelector,
    }),
    new Selector({
      selection: dayViewEndofContentSelector,
    }),
    new Selector({
      selection: timelineBarSelector,
    }),
    new Selector({
      selection: timelineUnitIsToday,
    }),
    new Selector({
      selection: dayViewActiveDateSelector,
    }),
    new Selector({
      selection: dayViewActiveDayLetterSelector,
    }),
    new Selector({
      selection: isTodayDate,
    }),
    new Selector({
      selection: momentsRegionHeader,
    }),
    new Selector({
      selection: dayViewEndofContentPostsContainerSelector,
    }),
    new Selector({
      selection: darkAttributeSelector,
      required: true,
    }),
    new Selector({
      selection: dayViewBackgroundImageSelector,
    }),
  ]

  const updateStyles = () => {
    document
      .querySelectorAll(dayViewBackgroundImageSelector)
      .forEach((element) => {
        element.style.top = '0'
      })

    document
      .querySelectorAll(dayViewSlideContentsSelector)
      .forEach((element) => {
        element.style['background-color'] = backgroundColor
        element.style.top = '80px'
      })

    document.querySelectorAll(contentHeaderSelector).forEach((element) => {
      element.style['background-color'] = 'unset'
    })

    document
      .querySelectorAll(viewerMomentsRegionSelector)
      .forEach((element) => {
        element.style.top = '235px'
        element.style['z-index'] = '1'
      })

    document
      .querySelectorAll(contentHeaderContentSelector)
      .forEach((element) => {
        element.style['background-color'] = 'unset'
        element.style['border-bottom'] = `1px solid ${secondaryBackgroundColor}`
      })

    document
      .querySelectorAll(viewerContentHeaderContentSelector)
      .forEach((element) => {
        element.style.height = '115px'
      })

    document.querySelectorAll(viewportSelector).forEach((element) => {
      element.style['background-color'] = 'unset'
      element.style['box-sizing'] = 'border-box'
      element.style['padding-top'] = '35px'
    })

    document.querySelectorAll(timelineSelector).forEach((element) => {
      element.style['background-color'] = transparentBackgroundColor
      element.style.height = '120px'
    })

    document.querySelectorAll(timelineRegionSelector).forEach((element) => {
      element.style.position = 'relative'
    })

    // Background Colors
    document.querySelectorAll(timelineBarSelector).forEach((element) => {
      element.style['background-color'] = `${secondaryBackgroundColor}`
    })

    document.querySelectorAll(timelineUnitIsToday).forEach((element) => {
      element.style['background-color'] = `${titleFontColor}`
    })

    document.querySelectorAll(activeSelector).forEach((element) => {
      element.style['background-color'] = `${backgroundColor}`
    })

    document.querySelectorAll(momentsRegionHeader).forEach((element) => {
      element.style['background-color'] = `${transparentBackgroundColor}`
      element.style.width = '100%'
      element.style.height = '70px'
      element.style.position = 'absolute'
      element.style.top = '235px'
      element.style['z-index'] = '0'
      element.style.display = 'flex'
      element.style['justify-content'] = 'space-between'
      element.style['align-items'] = 'center'
    })

    // Colors
    document.querySelectorAll(dayViewMonthSelector).forEach((element) => {
      element.style.color = transparentTitleFontColor
    })

    document.querySelectorAll(dayViewDateSelector).forEach((element) => {
      element.style.color = transparentTitleFontColor
    })

    document.querySelectorAll(dayViewActiveDateSelector).forEach((element) => {
      element.setAttribute('style', `color: ${titleFontColor} !important`)
    })

    document
      .querySelectorAll(dayViewActiveDayLetterSelector)
      .forEach((element) => {
        element.setAttribute('style', `color: ${titleFontColor} !important`)
      })

    document.querySelectorAll(momentDateSelector).forEach((element) => {
      element.style.color = transparentTitleFontColor
    })

    document.querySelectorAll(dayViewMomentTitleSelector).forEach((element) => {
      element.style.color = transparentTitleFontColor
    })

    document.querySelectorAll(isTodayDate).forEach((element) => {
      element.style.color = backgroundColor
    })

    // Grid Lines
    document
      .querySelectorAll(dayViewMomentColumnSelector)
      .forEach((element) => {
        element.style['border-left'] = 0
      })

    document
      .querySelectorAll(dayViewPostsContainerSelector)
      .forEach((element) => {
        element.style['border-left'] = `1px solid ${transparentBackgroundColor}`
      })

    document
      .querySelectorAll(dayViewEndofContentSelector)
      .forEach((element) => {
        element.style['border-right'] = 'unset'
      })

    document
      .querySelectorAll(dayViewEndofContentPostsContainerSelector)
      .forEach((element) => {
        element.style['border-right'] =
          `1px solid ${transparentBackgroundColor}`
        element.style.width = '542px'
        element.style['padding-left'] = 0
      })

    if (contentCardColor === 'light') {
      document.querySelectorAll(darkAttributeSelector).forEach((element) => {
        Array.from(element.classList).forEach((listItem) => {
          if (listItem.includes('--dark')) {
            const darkClassName = listItem
            const lightClassName = listItem.replace('--dark', '--light')
            element.classList.remove(darkClassName)
            element.classList.add(lightClassName)
          }
        })
      })
    }
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateDayView
